/**
 * API ведомости доставки «Собственной»: записи, которым нужно внимание.
 * Только чтение; данные кэшируются по ресурсу.
 */
import { baseApi, resourceScopeTag } from '@krp/client-runtime'

import { decodeOwnAttention, type OwnAttentionItem } from './contracts'
import { OWN_DELIVERY_URLS } from './urls'

export interface OwnAttentionArgs {
  resourceId: string
  /** `true` — только открытые; `false` — вместе с закрытыми. */
  openOnly: boolean
}

export const ownDeliveryApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Чтение ведомости; эффекта нет. Закрыть запись можно только в службе (право `receipts.devices.manage`). */
    ownDeliveryAttention: build.query<readonly OwnAttentionItem[], OwnAttentionArgs>({
      query: ({ resourceId, openOnly }) => ({
        url: OWN_DELIVERY_URLS.attention(resourceId),
        params: { openOnly },
        decode: decodeOwnAttention,
      }),
      providesTags: (_result, _error, { resourceId }) => [resourceScopeTag(resourceId)],
    }),
  }),
})

export const { ownDeliveryAttention } = ownDeliveryApi.endpoints
